import { objectToQueryString } from 'site-modules/shared/utils/string';

export const getPersonalizedSearchPageRoute = () => `/search/`;

export const getPersonalizedSearchRouteWithKeyParam = searchId =>
  searchId
    ? `${getPersonalizedSearchPageRoute()}?${objectToQueryString({ key: searchId })}`
    : getPersonalizedSearchPageRoute();
